module.exports = __webpack_public_path__ + "static/image/product-unrelated.svg?37484892e3097df7f295205d4a364aeb";